<template>
    <!-- <el-button class="mr-2" :disabled="loading" type="warning" size="large" @click="dialog = true">Import</el-button> -->

    <el-dialog style="min-width: 400px" title="Import Data" v-model="dialog">
        <el-form-item :label="label" label-position="top">
            <el-upload
                :disabled="loading"
                class="w-100"
                drag
                :limit="1"
                :on-exceed="onExceed"
                :action="uploadUrl"
                :data="uploadData"
                :file-list="fileList"
                :before-upload="beforeUpload"
                :on-success="handleSuccess"
                :on-error="handleError"
            >
                <i class="fa-solid fa-cloud-arrow-up fa-2xl pa-4 text-primary"></i>
                <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                <template #tip>
                    <div class="el-upload__tip">Excel file with a size less than 10MB</div>
                </template>
            </el-upload>
            <v-progress-circular v-if="loading" color="primary" indeterminate></v-progress-circular>
        </el-form-item>
        <template #footer>
            <div>
                <el-button @click="importData" type="success" size="large">Import</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script lang="ts" setup>
    import { ref, computed } from 'vue'
    import { ElMessage } from 'element-plus'
    import { useAuthStore } from '@/stores/auth'
    // import axios from '@/utils/apiClient'
    import axios from '@/utils/apiClient'
    const authStore = useAuthStore()
    const emit = defineEmits(['update:modelValue', 'success'])

    const props = defineProps({
        modelValue: {
            type: String,
            default: null,
        },
        endpoint: {
            type: String,
            require: true,
        },
        label: {
            type: String,
            default: 'Upload File',
        },
    })
    const filePath = ref(null)
    const dialog = ref(false)
    const loading = ref(false)
    const fileList = ref([])
    const uploadData = ref({
        folder: 'uploads',
        privateFile: true,
        token: authStore.user.token,
    })

    const uploadUrl = computed(() => {
        const baseUrl = process.env.NODE_ENV === 'production' ? window.location.origin : 'https://localhost:7157'
        return `${baseUrl}/api/fileuploader`
    })

    const beforeUpload = file => {
        const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        if (!isExcel) {
            ElMessage.error('Only excel file is allowed')
            return false // Prevent file upload
        }
        if (file.size > 1024 * 1024 * 10) {
            // Limit file size to 10MB
            ElMessage.error('File size cannot exceed 10MB')
            return false // Prevent file upload
        }
        loading.value = true
        return true
    }

    const handleSuccess = (response, file, fileList) => {
        filePath.value = response.fileName
        loading.value = false
        emit('update:modelValue', response.fileName)
    }

    const handleError = (error, file, fileList) => {
        loading.value = false
        ElMessage.error('Upload failed')
    }
    const onExceed = (files, fileList) => {
        ElMessage.error(`The limit is 1 file, you selected ${files.length} files, please delete one and try again`)
    }

    const importData = async () => {
        if (!filePath.value) {
            ElMessage.error('Please upload file first')
            return
        }
        const res = await axios.get(props.endpoint + '/Import?filePath=' + filePath.value)
        if (res.status == 200) {
            ElMessage.success('Import data successful')
            dialog.value = false
            fileList.value = []
            emit('success')
        }
    }
</script>
